/*
 * Copyright (c) Worldline 2023.
 */

export enum EvidenceTemplates {
    EVIDENCES_TEMPLATE_ANALYSE,
    EVIDENCES_TEMPLATE_CROPPING,
    EVIDENCES_TEMPLATE_GLOBAL,
    NONE
}